<template>
  <div id="date-selector">
    <div class="previous-month">
      <img
        src="/static/icons/toggle-icon.svg"
        class="previous-month-icon"
        @click="showPreviousMonth"
      />
    </div>
    <date-picker
      :value="date"
      @input="dateChanged"
      :inputFormat="inputFormat"
      :titleFormat="titleFormat"
    />
    <div class="next-month">
      <img
        src="/static/icons/toggle-icon.svg"
        class="next-month-icon"
        @click="showNextMonth"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DateSelector",
  props: {
    inputFormat: {
      type: String,
      required: false,
      default: "YYYY. MMMM DD."
    },
    titleFormat: {
      type: String,
      required: false,
      default: "YYYY. MMMM DD."
    },
    interval: {
      type: String,
      required: false,
      default: "month"
    },
    value: {
      required: false
    }
  },
  components: {},
  data() {
    return {
      date: undefined
    };
  },
  created() {
    this.date = this.$moment(this.value).format("YYYY-MM-DD");
  },
  watch: {
    date() {
      this.$emit("input", this.$moment(this.date).format("YYYY-MM-DD"));
    }
  },
  computed: {},
  methods: {
    showPreviousMonth() {
      this.date = this.$moment(this.date)
        .subtract(1, this.interval)
        .format("YYYY-MM-DD");
    },
    showNextMonth() {
      this.date = this.$moment(this.date)
        .add(1, this.interval)
        .format("YYYY-MM-DD");
    },
    dateChanged(payload) {
      this.date = this.$moment(payload).format("YYYY-MM-DD");
    }
  }
};
</script>

<style lang="scss" scoped>
#date-selector {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  height: calc(25px + 10px + 10px);
  .previous-month {
    margin-right: 30px;
    .previous-month-icon {
      cursor: pointer;
      height: 10px;
      transform: rotate(-90deg);
    }
  }
  .today {
    font-size: 22px;
    line-height: 25px;
  }
  .next-month {
    margin-left: 30px;
    .next-month-icon {
      cursor: pointer;
      height: 10px;
      transform: rotate(90deg);
    }
  }
}
</style>
